"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { AuthDialog } from "@/components/auth/auth-dialog";
import type { ProductDetail } from "./types";
import { useClaimGateShown } from "./use-claim-gate-shown";
import { recycleAvailabilityNotice } from "./listing-recycle-action";

export function ListingRecycleSignInGate({ data }: { data: ProductDetail }) {
  const unavailable = recycleAvailabilityNotice(data);
  if (unavailable) return unavailable;
  return <RecycleSignInAction data={data} />;
}

function RecycleSignInAction({ data }: { data: ProductDetail }) {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const free = data.isFreePickup;
  useClaimGateShown(data._id, "sign_in");

  return (
    <div className="space-y-3">
      <Button variant="primary" className="w-full" onClick={() => setOpen(true)}>
        {free ? "Claim this listing" : "Respond to this listing"}
      </Button>
      <p className="text-center text-xs leading-relaxed text-muted-foreground">
        {free
          ? "Free items are claimed by Pro members."
          : "Offers on recycle listings are made by Pro members."}
      </p>
      <AuthDialog
        open={open}
        onOpenChange={setOpen}
        entryPoint="listing_claim"
        reason={free ? "Log in to claim this listing." : "Log in to respond to this listing."}
        onSignedIn={() => {
          setOpen(false);
          router.refresh();
        }}
      />
    </div>
  );
}
